{
	"app": {
		"name": "Results",
		"fullName": "On Venue Results",
		"wordmark": "OVR",
		"tagline": "On-venue results"
	},
	"state": {
		"loading": "Loading…"
	},
	"filterPanel": {
		"title": "Filters",
		"active_one": "{{count}} filter set",
		"active_other": "{{count}} filters set"
	},
	"actions": {
		"back": "Back",
		"cancel": "Cancel",
		"close": "Close",
		"confirm": "Confirm",
		"discard": "Discard",
		"keepMine": "Keep mine",
		"reload": "Reload",
		"retry": "Try again",
		"save": "Save",
		"signOut": "Sign out",
		"takeTheirs": "Take theirs"
	},
	"connection": {
		"online": "Online",
		"degraded": "Server busy",
		"offline": "Offline",
		"onlineHint": "Connected. Saves go straight to the server.",
		"degradedHint": "The server is not answering properly. Your edits are kept and will be sent again.",
		"offlineHint": "No connection. Your edits are kept on this device until the connection is back."
	},
	"shell": {
		"continueAs": "Continue as {{role}}",
		"gamesLogo": "SEA Games 2027",
		"noActiveRole": "No active role",
		"readOnlyBadge": "View only",
		"readOnlyHint": "Your role can view results but not enter them.",
		"signedInAs": "Signed in as {{role}}",
		"skipToContent": "Skip to content",
		"switchRole": "Switch role"
	},
	"roles": {
		"SUPER_ADMIN": "Super Admin",
		"ADMIN": "Admin",
		"MEDAL_DESK": "Medal desk",
		"OPERATION": "Operation",
		"ORGANIZATION": "Organization",
		"TRANSPORT_PROVIDER": "Transport provider",
		"HOTEL": "Hotel",
		"WORKFORCE": "Workforce",
		"PARTICIPANT": "Participant",
		"PUBLIC": "Public"
	},
	"scheduleStatus": {
		"TENTATIVE": "Tentative",
		"SCHEDULED": "Scheduled",
		"DELAYED": "Delayed",
		"INTERRUPTED": "Interrupted",
		"POSTPONED": "Postponed",
		"CANCELLED": "Cancelled"
	},
	"resultStatus": {
		"NONE": "No result",
		"START_LIST": "Start list",
		"LIVE": "Live",
		"UNOFFICIAL": "Unofficial",
		"OFFICIAL": "Official"
	},
	"irm": {
		"DNS": "Did not start",
		"DNF": "Did not finish",
		"DSQ": "Disqualified",
		"NM": "No mark",
		"WD": "Withdrawn",
		"WO": "Walkover",
		"RET": "Retired",
		"DNC": "Did not come to the start",
		"OCS": "On course side at the start",
		"BFD": "Black flag disqualification",
		"UFD": "U flag disqualification",
		"DNE": "Disqualification, not excludable",
		"RDG": "Redress given",
		"DPI": "Discretionary penalty imposed",
		"SCP": "Scoring penalty applied",
		"ZFP": "20% scoring penalty",
		"STP": "Standard penalty",
		"DCT": "Disqualified after a collision",
		"NSC": "Did not sail the course",
		"LAP": "Lapped, not placed",
		"OTL": "Outside the time limit",
		"REL": "Relegated",
		"CUT": "Missed the cut",
		"EL": "Eliminated",
		"FTQ": "Failed to qualify",
		"PEN": "Penalised"
	},
	"outcome": {
		"WIN": "Win",
		"LOSS": "Loss",
		"DRAW": "Draw",
		"BYE": "Bye"
	},
	"qualification": {
		"BY_PLACE": "Qualified by place",
		"BY_PERFORMANCE": "Qualified by performance",
		"BY_DECISION": "Qualified by decision",
		"RESERVE": "Reserve"
	},
	"eventGender": {
		"MEN": "Men",
		"WOMEN": "Women",
		"MIXED": "Mixed",
		"OPEN": "Open"
	},
	"family": {
		"TIMED": "Timed",
		"ATTEMPTS": "Attempts",
		"SETS": "Sets and periods",
		"BOUT": "Bout",
		"JUDGED": "Judged",
		"ROUNDS": "Rounds",
		"LIFTS": "Lifts",
		"GENERIC": "Generic"
	},
	"rowState": {
		"clean": "Saved",
		"dirty": "Not saved yet",
		"saving": "Saving…",
		"saved": "Saved",
		"conflict": "Changed by someone else",
		"refused": "Not accepted"
	},
	"stub": {
		"beingBuilt": "This screen is being built.",
		"family": "Result family: {{family}}"
	},
	"notFound": {
		"title": "Page not found",
		"body": "This address does not match any screen in Results.",
		"home": "Go to the dashboard"
	},
	"routeError": {
		"title": "This screen could not load",
		"unreachable": "Can't reach the server",
		"requestId": "Request ID"
	},
	"session": {
		"checking": "Checking your session…",
		"checkingNow": "Trying again…",
		"unreachableBody": "Your work on this device is kept. Retrying automatically — the app opens as soon as the server answers.",
		"nextTry": "Next try in {{seconds}} s",
		"tryNow": "Try now"
	},
	"noAccess": {
		"title": "No access to results entry",
		"body": "Ask your administrator for a role that can use Results.",
		"reasonRole": "The {{role}} role does not include results entry.",
		"reasonNoRole": "Your account has no active role."
	},
	"ui": {
		"dataTable": {
			"action": "Action",
			"errorTitle": "Couldn't load this list",
			"tryAgain": "Try again",
			"emptyTitle": "Nothing here yet",
			"selected": "selected",
			"onOtherPages": "{{n}} on other pages",
			"clear": "Clear",
			"columns": "Columns",
			"showColumns": "Show columns",
			"always": "always",
			"showAll": "Show all",
			"hiddenCount": "{{n}} hidden",
			"selectRow": "Select row {{row}}",
			"selectAllRows": "Select all rows on this page",
			"deselectAllRows": "Deselect all rows on this page"
		},
		"pagination": {
			"label": "Pagination",
			"summary_one": "{{from}}–{{to}} of {{total}} result",
			"summary_other": "{{from}}–{{to}} of {{total}} results",
			"summaryWithNoun": "{{from}}–{{to}} of {{total}} {{noun}}",
			"empty": "No results",
			"emptyWithNoun": "No {{noun}}",
			"rowsPerPage": "Rows per page",
			"firstPage": "First page",
			"previousPage": "Previous page",
			"nextPage": "Next page",
			"lastPage": "Last page",
			"page": "Page {{page}}"
		},
		"select": {
			"placeholder": "Select…",
			"searchPlaceholder": "Search…",
			"noMatches": "No matches",
			"clear": "Clear",
			"removeOption": "Remove {{label}}",
			"selectedCount": "{{n}} selected",
			"selectAll": "Select all"
		},
		"filterBar": {
			"label": "Filters",
			"apply": "Filter",
			"reset": "Reset"
		},
		"modal": {
			"close": "Close"
		}
	},
	"athleteNumber": {
		"BIB": "Bib",
		"SHIRT": "Shirt No.",
		"CAP": "Cap No.",
		"BACK": "Back No.",
		"SAIL": "Sail No.",
		"HELMET": "Helmet No.",
		"LOT": "Lot No."
	}
}
